import React from 'react';
import { Box, Typography } from '@mui/material';

const LogTrail = ({ logs }) => (
    <Box sx={{ mt: 2, maxHeight: 200, overflowY: 'auto' }}>
        <Typography variant="subtitle1" sx={{ color: '#12c099', mb: 1 }}>Log Trail:</Typography>
        {logs.map((log, i) => (
            <Typography key={i} variant="body2" sx={{ color: '#aaa', fontFamily: 'monospace' }}>
                {log}
            </Typography>
        ))}
    </Box>
);

export default LogTrail;
